import { useMutation } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { queryClient } from '@/api/react-query'
import { customerApplicationsQueryKey } from '@/api/financial/customer/list-customer-applications'
import { applicationQueryKey } from '@/api/financial/application/read-application'

function invalidate(applicationKey: string) {
  queryClient.invalidateQueries({ queryKey: applicationQueryKey(applicationKey) })
  queryClient.invalidateQueries({ queryKey: customerApplicationsQueryKey })
  queryClient.invalidateQueries({ queryKey: ['customer-context', 'financial'] })
}

export function usePreAnalysis(applicationKey: string) {
  return useMutation({
    mutationFn: async () => {
      await httpClient('financial').post(
        `/v1/committee/${applicationKey}/pre-analisys`,
      )
    },
    onSuccess: () => invalidate(applicationKey),
  })
}

export function useSendCommittee(applicationKey: string) {
  return useMutation({
    mutationFn: async () => {
      await httpClient('financial').post(`/v1/committee/${applicationKey}/send`)
    },
    onSuccess: () => invalidate(applicationKey),
  })
}

export function useAcceptProposal(applicationKey: string) {
  return useMutation({
    mutationFn: async (proposalKey: string) => {
      await httpClient('financial').post(`/v1/proposal/${proposalKey}/accept`)
    },
    onSuccess: () => invalidate(applicationKey),
  })
}

export function useReissueProposal(applicationKey: string) {
  return useMutation({
    mutationFn: async (proposalKey: string) => {
      await httpClient('financial').post(`/v1/proposal/${proposalKey}/reissue`)
    },
    onSuccess: () => invalidate(applicationKey),
  })
}
